/* eslint-disable @angular-eslint/no-inputs-metadata-property */

import { Component, HostBinding, Input } from '@angular/core';
import { ThemeColorDirective } from '../../directives/theme-color';

@Component({
    selector: 'lui-tag',
    template: `<ng-content></ng-content>`,
    styleUrls: ['./tag.scss'],
    hostDirectives: [
        {
            directive: ThemeColorDirective,
            inputs: ['color'],
        },
    ],
    standalone: false
})
export class TagComponent {
  @Input() collapsed = false;
  @Input() size: 'md' | 'sm' | 'xs' = 'md';

  @HostBinding('class') hostClass = 'lui-tag';
  @HostBinding('class.lui-tag-collapsed') get collapsedClass() {
    return this.collapsed;
  }
  @HostBinding('class.lui-tag-sm') get smallClass() {
    return this.size === 'sm';
  }
  @HostBinding('class.lui-tag-xs') get xsClass() {
    return this.size === 'xs';
  }
}
